import { 
  FavouriteDefinition, FavouriteCondition, 
  FavouriteConditionValue, FavouriteConnections, 
  ReportDefinition, SelectionDefinition 
} from 'app/types-shared';
import { deepEquals } from 'app/infrastructure/js';

export function favouriteDefinitionsAreEqual(definitionA: FavouriteDefinition, definitionB: FavouriteDefinition) {
  const dataA = getFavouriteDefinitionData(definitionA);
  const dataB = getFavouriteDefinitionData(definitionB);

  return deepEquals(dataA, dataB);
}

function getFavouriteDefinitionData(definition: FavouriteDefinition) {
  return {
    emailSubscribers: definition?.emailSubscribers,
    favourite: definition?.favourite?.v,
    selectedReport: definition?.selectedReport?.v,
    conditions: (definition?.conditions || []).map(getConditionData),
    connections: (definition?.connections || []).map(getConnectionData),
    exposureApplication: definition?.exposureApplication?.v,
    exposureFactor: definition?.exposureFactor,
    exposurePercent: definition?.exposurePercent,
    reports: (definition?.reports || []).map(getReportData)
  };
}

function getReportData(report: ReportDefinition) {
  return {
    report: report?.report?.v,
    aggregationType: report?.aggregationType?.v,
    targetApp: report?.targetApp?.v,
    aggregationDomain: report?.aggregationDomain?.v,
    specialReport: report?.specialReport?.v,
    layoutType: report?.layoutType?.v,
    layoutAttributes: report?.layoutAttributes,
    uomSetDomain: report?.uomSetDomain?.v,
    type: report?.type?.v,
    sort: report?.sort,
    selections: (report?.selections || []).map(getSelectionData),
    options: report?.options,
    excludedOptions: report?.excludedOptions,
    rollingAverage: report?.rollingAverage,
    predefDate: report?.predefDate,
    drillDownReport: report?.drillDownReport,
    includedFields: report?.includedFields,
    drillDownLayoutType: report?.drillDownLayoutType
  };
}

function getSelectionData(selection: SelectionDefinition) {
  return {
    id: selection?.id,
    domain: selection?.domain?.v,
    interval: selection?.interval,
    levels: selection?.levels,
    period: selection?.period?.v,
    type: selection?.type?.v,
    setLevelAccToCond: selection?.setLevelAccToCond,
    fillEmpty: selection?.fillEmpty,
    selectedCode: selection?.selectedCode,
    sortOrderType: selection?.sortOrderType?.v
  };
}

function getConnectionData(connection: FavouriteConnections) {
  return {
    connected: connection?.connected?.v,
    operator: connection?.operator?.v
  };
}

function getConditionData(condition: FavouriteCondition) {
  return {
    domainDbFunction: condition?.domainDbFunction?.v,
    domain: condition?.domain?.v,
    valueOperator: condition?.valueOperator?.v,
    conditionOperator: condition?.conditionOperator?.v,
    conditionOperator2: condition?.conditionOperator2?.v,
    extraSqlCondition: condition?.extraSqlCondition,
    exactLevel: condition?.exactLevel,
    forceExists: condition?.forceExists,
    values: (condition?.values || []).map(getConditionValueData)
  };
}

function getConditionValueData(conditionValue: FavouriteConditionValue) {
  return {
    dbFunction: conditionValue?.dbFunction?.v,
    operator: conditionValue?.operator?.v,
    periodPredef: conditionValue?.periodPredef?.v,
    code: conditionValue?.code?.v,
    number: conditionValue?.number,
    number2: conditionValue?.number2,
    string: conditionValue?.string,
    date: conditionValue?.date,
    myValue: conditionValue?.myValue
  };
}
